/**
 * @author PoornaChandu
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import cloneDeep from 'lodash.clonedeep';
import { LeftOutlined } from '@ant-design/icons';
// import { createStructuredSelector } from 'reselect';
import { Input, Row, Col, message, Button, Tabs } from 'antd';
// import history from '../../commons/history';
import {
  saveRule,
  ruleListID,
  editRule,
  // urlList,
  deviceList,
  getparameterChangeList,
  // getDeviceData,
  // recipientListAPI,
  getparameterList,
  getparameterListByDeviceType,
  // nodeviceParameterList,
  // tablesList,
  getColumnsList,
  priorityList,
  getHierarchyLevels,
  deviceTypeListData
  // getUserHierarcy
  // getParamtersListWithType
} from './Apicalls';
import { DeviceRuleView, DeviceTypeRule } from './Tabs';
import {
  defaultState,
  deviceTypedefaultState,
  predictionDefaultState,
  noDeviceDefault,
  tableState
  // recipientState
} from './utils/const';
import localStorage from '../../utils/localStorage';
import scriptGenerator, { replicateRule } from './scriptGenerator';
// import { getUserProfile } from '../../selectors/layout';
import { BlockedLabel } from './style';
// import { getTranslationCache } from '../../selectors/language';
import constants from './constants';
import { useParams, useNavigate } from 'react-router-dom';
import { StyledHomepage } from '../../commons/styles/layout';
const { TabPane } = Tabs;
const RuleEngine = (props) => {
  const navigate = useNavigate();
  const [state, setState] = useState(cloneDeep(defaultState));
  const { id } = useParams();
  const [batchPriority, setBatchPriority] = useState('');
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [treeData, setTreeData] = useState([]);
  const [indexDevice1, setIndexDevice1] = useState(0);
  const [indexDevice, setIndexDevice] = useState('');
  const [onContinous, setOnContinous] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [enable, setEnable] = useState(false);
  const [parameterChangeList, setParameterChangeList] = useState([]);
  const [parameterName, setParameterName] = useState('');
  const [runCount, setRunCount] = useState(0);
  const [permissionsArray, setPermissionsArray] = useState([]);
  const Conif = true;
  useEffect(() => {
    // if(id){setState({
    //   ...state,
    //   edit:true,
    // });}
    setUserProfile(props.userProfile);
  }, [props.userProfile]);

  useEffect(() => {}, [state.ruleType]);

  useEffect(() => {
    // let Data1 = deviceList();
    const fetchData = async () => {
      try {
        if (id) {
          let data = await ruleListID(id);
          let Data = await deviceList();
          let deviceTypeList = await deviceTypeListData();
          let deviceListData = Data?.data
            ? Object.keys(Data.data).map((devicekey) => Data.data[devicekey])
            : [];
          let ParameterChangeList = await getparameterChangeList();
          let priorityData = await priorityList();
          setSelectedEquipment(data.data[0].Payload.selectedDevices);
          setParameterName(data.data[0].Payload.inputList[0].parameterName);
          setBatchPriority(data.data[0].Payload.batchPriority);
          setParameterChangeList(ParameterChangeList);
          setOnContinous(onContinous);
          defaultState.deviceList = deviceListData;
          tableState.deviceList = deviceListData;
          deviceTypedefaultState.deviceTypeList = deviceTypeList;

          setState((prevState) => ({
            ...prevState,
            deviceTypeList: deviceTypeList,
            edit: true,
            priorityTypes: priorityData
          }));
          let HierachyLevels= userProfile?.belongsTo?.sites?.[localStorage.get('currentSite')]?.hierarchy || [];
          let hierarchyDefault = HierachyLevels[0]?.HierarchyCode;
          // let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
          let Data1 = await getHierarchyLevels(hierarchyDefault, state.inputList[0].parameterName);
          setTreeData(Data1);
          data.data[0].Payload.edit = true;
          if (data.data[0].Payload.tabActivationkey === 'DeviceTypeRules') {
            let parametersList = await getparameterListByDeviceType(
              data.data[0].Payload.parameter,
              data.data[0].Device
            );
            setState({
              ...state,
              parametersList: parametersList,
              ParameterCode: data.data[0].Payload.ParameterCode,
              deviceListData: deviceListData,
              inputList: data.data[0].Payload.inputList,
              tabActivationkey: data.data[0].Payload.tabActivationkey,
              deviceTypeList: deviceTypeList,
              mailRecipients: data.data[0].Payload.mailRecipients,
              NumberOfNotifications: data.data[0].Payload.NumberOfNotifications,
              ruleDesc: data.data[0].Payload.ruleDesc,
              ruleMode: data.data[0].Payload.ruleMode,
              ruleType: data.data[0].Payload.ruleType,
              name: data.data[0].Payload.name,
              displayRuleName: data.data[0].Payload.displayRuleName,
              Group: data.data[0].Payload.Group,
              edit: true
            });
          } else {
            let parametersData = await getparameterList(
              data.data[0].Device,
              data.data[0].Payload.inputList[0].parameterName
            );
            let parametercode = data.data[0].Payload.ParameterCode;

            setState({
              ...state,
              ParameterCode: parametercode,
              deviceListData: deviceListData,
              inputList: data.data[0].Payload.inputList,
              deviceTypeList: deviceTypeList,
              mailRecipients: data.data[0].Payload.mailRecipients,
              NumberOfNotifications: data.data[0].Payload.NumberOfNotifications,
              selectedDevices: data.data[0].Payload.selectedDevices,
              replicateDevices: data.data[0].Payload.replicateDevices,
              ruleDesc: data.data[0].Payload.ruleDesc,
              ruleType: data.data[0].Payload.ruleType,
              displayRuleName: data.data[0].Payload.displayRuleName,
              parametersList: parametersData.data,
              edit: true
            });
            if (!state.priorityTypes) {
              setState((prevState) => ({
                ...prevState,
                priorityTypes: priorityData
              }));
            }
          }
        } else {
          handleParameterSelect('Operational', 0, 'inputList');
          let ParameterChangeList = await getparameterChangeList();
          let data = await deviceList();
          let deviceTypeList = await deviceTypeListData();
          let deviceListData = data?.data
            ? Object.keys(data.data).map((devicekey) => data.data[devicekey])
            : [];
          setState({
            ...state,
            deviceListData: deviceListData,
            deviceTypeList: deviceTypeList
          });
          setParameterChangeList(ParameterChangeList);
          setOnContinous(onContinous);
          defaultState.deviceList = deviceListData;
          tableState.deviceList = deviceListData;
          deviceTypedefaultState.deviceTypeList = deviceTypeList;
          let HierachyLevels= userProfile?.belongsTo?.sites?.[localStorage.get('currentSite')]?.hierarchy || [];
          let hierarchyDefault = HierachyLevels[0]?.HierarchyCode;
          // let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
          let Data = await getHierarchyLevels(hierarchyDefault, state.inputList[0].parameterName);
          setTreeData(Data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (runCount < 10) {
      fetchData();
      setRunCount((prevCount) => prevCount + 1);
    }
    const initialDeviceList = async () => {
      let ParameterChangeList = await getparameterChangeList();
      let data = await deviceList();
      let deviceTypeList = await deviceTypeListData();
      let deviceListData = data?.data
        ? Object.keys(data.data).map((devicekey) => data.data[devicekey])
        : [];
      setState({
        ...state,
        deviceList: deviceListData,
        deviceListData: deviceListData,
        deviceTypeList: deviceTypeList,
      });
      setParameterChangeList(ParameterChangeList);
      setOnContinous(onContinous);
      defaultState.deviceList = deviceListData;
      tableState.deviceList = deviceListData;
      deviceTypedefaultState.deviceTypeList = deviceTypeList;
      let HierachyLevels= userProfile?.belongsTo?.sites?.[localStorage.get('currentSite')]?.hierarchy || [];
      let hierarchyDefault = HierachyLevels[0]?.HierarchyCode;
      //  let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
      let Data = await getHierarchyLevels(hierarchyDefault, state.inputList[0].parameterName);
      setTreeData(Data);
    };
    initialDeviceList();
  }, [id, runCount]);

  useEffect(() => {
    const currentSite = localStorage.get('currentSite');
    const newPermissionsArray = [];
    if (
      userProfile &&
      userProfile.belongsTo &&
      userProfile.belongsTo.sites &&
      userProfile.belongsTo.sites[currentSite] &&
      userProfile.belongsTo.sites[currentSite].role &&
      userProfile.belongsTo.sites[currentSite].role.Permission
    ) {
      userProfile.belongsTo.sites[currentSite].role.Permission.filter(
        (item) => item.resource === 'rule_engine'
      ).forEach((name) => newPermissionsArray.push(name.action));
    }
    setPermissionsArray(newPermissionsArray);
  }, [userProfile]);

  const handleInputChange = (e, index, type, mode) => {
    if (type === 'select') {
      const list = [...state[mode]];
      list[index]['operater'] = e;
      setState({
        ...state
        // [[mode][index]['operator']]: e
      });
    } else {
      const { name, value } = e.target;
      const list = [...state[mode]];
      list[index][name] = value;
      setState({
        ...state
        //  [[mode][index]['value']]: value
      });
    }
  };

  const handleTextAreaChange = (e, index, mode, dignosis) => {
    let list = [...state[mode]];
    list[index][dignosis] = e.target.value;
    setState({
      ...state,
      [mode]: list
    });
  };
  const handleRemoveClick = (index, mode) => {
    const list = [...state[mode]];
    if (index === list.length - 1) {
      let currentIndex = list.length - 2;
      let prevIndex = list.length - 1;
      list[currentIndex]['action'] = list[prevIndex]['action'];
      list[currentIndex]['delay'] = list[prevIndex]['delay'];
      list[currentIndex]['frequency'] = list[prevIndex]['frequency'];
      list[currentIndex]['preventive'] = list[prevIndex]['preventive'];
      list[currentIndex]['rootcause'] = list[prevIndex]['rootcause'];
      list[currentIndex]['recommandation'] = list[prevIndex]['recommandation'];
      list.splice(index, 1);
    } else {
      list.splice(index, 1);
    }
    setState({
      ...state,
      [mode]: list
    });
  };
  const handleAddClick = (mode) => {
    let typeList = [...state[mode]];
    let index = indexDevice1 + 1;
    setIndexDevice1(index);

    if (
      typeList[0].parameterName !== '' &&
      typeList[0].HierarchyId !== '' &&
      typeList[0].device !== ''
    ) {
      let index = typeList.length - 1;
      if (state.ruleType === 'realTime') {
        let newItem = {
          parameterName: typeList[index]['parameterName'],
          device: typeList[index]['device'],
          tagName: '',
          operater: '',
          value: '',
          HierarchyId: typeList[index]['HierarchyId'],
          action: typeList[index]['action'],
          delay: typeList[index]['delay'],
          frequency: typeList[index]['frequency'],
          preventive: typeList[index]['preventive'],
          rootcause: typeList[index]['rootcause'],
          recommandation: typeList[index]['recommandation'],
          54765: ''
        };
        delete typeList[index]['action'];
        delete typeList[index]['delay'];
        delete typeList[index]['frequency'];
        delete typeList[index]['preventive'];
        delete typeList[index]['rootcause'];
        delete typeList[index]['recommandation'];
        setEnable(false);
        setState({
          ...state,
          [[mode][0]]: [...typeList, newItem]
          // disabledParamTypeDevice: true
        });
      } else if (state.ruleType === 'hybrid') {
        let newItem = {
          parameterName: typeList[index]['parameterName'],
          device: typeList[index]['device'],
          tagName: '',
          operater: '',
          value: '',
          HierarchyId: typeList[index]['HierarchyId'],
          action: typeList[index]['action'],
          delay: typeList[index]['delay'],
          frequency: typeList[index]['frequency'],
          preventive: typeList[index]['preventive'],
          rootcause: typeList[index]['rootcause'],
          recommandation: typeList[index]['recommandation'],
          54765: ''
        };
        delete typeList[index]['action'];
        delete typeList[index]['delay'];
        delete typeList[index]['frequency'];
        delete typeList[index]['preventive'];
        delete typeList[index]['rootcause'];
        setState({
          ...state,
          [mode]: [...typeList, newItem]
        });
      } else {
        let newItem = {
          tagName: '',
          operater: '',
          value: '',
          action: typeList[index]['action'],
          delay: typeList[index]['delay'],
          frequency: typeList[index]['frequency'],
          preventive: typeList[index]['preventive'],
          rootcause: typeList[index]['rootcause'],
          recommandation: typeList[index]['recommandation'],
          54765: ''
        };
        delete typeList[index]['action'];
        delete typeList[index]['delay'];
        delete typeList[index]['frequency'];
        delete typeList[index]['preventive'];
        delete typeList[index]['rootcause'];
        setState({
          ...state,
          [mode]: [...typeList, newItem]
        });
      }
      delete typeList[index]['recommandation'];
      // if (state.ruleType=== 'realTime') {
      //   if (typeList[0].device === '') {
      //     message.error('Please Select Equipment to Add New Condition in Real Time');
      //   } else {
      //     newItem.device = typeList[0].device;
      //     this.setState({ [mode]: [...typeList, newItem] });
      //   }
      // } else {
      // this.setState({ [mode]: [...typeList, newItem] });
      // }
    } else {
      message.warning('Please select required fields');
    }
  };
  const handleConditionchange = (e, index, mode) => {
    const list = [...state[mode]];
    list[index]['54765'] = e;
    setState({
      ...state,
      [mode]: list
    });
  };
  const saveRules = async () => {
    setState(state);
    const result = scriptGenerator(state);
    if (result.errorClearnce) {
      const {
        displayRuleName,
        ruleDesc,
        ruleType,
        batchPriority,
        onChange,
        replicateDevices,
        ParameterCode,
        Group,
        NumberOfNotifications
      } = state;
      // for (let prop in state) {
      //   // let flage = prop.startsWith('param');
      //   // if (flage) setState({ [prop]: [] });
      // }
      const replicateList = replicateDevices;
      // setState({ replicateDevices: [] });
      try {
        let payLoad = {
          name: displayRuleName,
          displayRuleName: displayRuleName,
          description: ruleDesc,
          NumberOfNotifications: NumberOfNotifications === '' ? null : NumberOfNotifications,
          payload: {
            ...state,
            treeData: [],
            userProfile: {},
            parameterChangeList: [],
            deviceList: [],
            deviceTypeList: [],
            // parametersList: [],
            recipientList: []
          },
          tags: result.tagNames,
          script: result.script,
          ParameterCode: ParameterCode,
          ruleType,
          batchPriority,
          onChange,
          onContinous: onContinous,
          replicate: 'false',
          mailRecipients: state.mailRecipients ? state.mailRecipients : [],
          url: state.url ? state.url : [],
          ...(ruleType && ruleType === 'deviceType' ? { Group } : {})
        };
        let data = await saveRule(payLoad);
        if (data.status === 201 || data.status === 200) {
          message.success('Rule Created');
          if (ruleType === 'batch' && replicateList.length > 0) {
            let deviceList = result.tagNames.map((tag) => {
              return tag.device;
            });
            const uniqueDevice = [...deviceList];
            if (uniqueDevice.length > 1) {
              // setState(defaultState);
              message.error('Rule Cannot Be Replicated For multiple Devices');
              return;
            }
          }
          if (replicateList.length > 0) {
            replicateList.map(async (replicateDevice, i) => {
              let replicatedState = {
                ...replicateRule(state, replicateDevice)
              };
              const result = scriptGenerator(replicatedState);
              replicatedState.replicateDevices = [];
              try {
                let repData = await saveRule({
                  name: displayRuleName,
                  displayRuleName: displayRuleName,
                  description: ruleDesc,
                  payload: replicatedState,
                  tags: result.tagNames,
                  script: result.script,
                  ruleType,
                  batchPriority,
                  onChange,
                  onContinous: onContinous,
                  replicate: 'true',
                  mailRecipients: state.mailRecipients ? state.mailRecipients : [],
                  parentId: data.data && data.data.Id ? data.data.Id : ''
                });
                if (repData.status === 201 || repData.status === 200) {
                  message.success('Rule Created');
                }
                if (i === replicateList.length - 1) {
                  setState(cloneDeep(defaultState));
                }
              } catch (error) {
                if (error.response && error.response.status === 400) {
                  message.error(error.response.data.message);
                }
                if (i === replicateList.length - 1) {
                  setState(cloneDeep(defaultState));
                }
              }
            });
          }
          if (state.ruleType === 'restApi') {
            setState(cloneDeep(predictionDefaultState));
          } else if (state.ruleType === 'noDevice') {
            setState(cloneDeep(noDeviceDefault));
          } else {
            setState(cloneDeep(defaultState));
          }
          navigate(`/rubus/RulesList`);
        }
      } catch (error) {
        if (error && error.response && error.response.status === 400) {
          message.error(error.response.data.message);
        }
      }
    }
  };
  const handleelseif = () => {
    if (!state.conelse) {
      const elsifLength = [...state.elsifLength];
      let prop = `elseif${state.elsifNumber + 1}`;
      elsifLength.push(prop);
      let obj = {
        conif: true,
        conelseif: true,
        conelse: false,
        elsifNumber: state.elsifNumber + 1,
        elsifLength,
        [prop]: [
          {
            tagName: '',
            operater: '',
            value: '',
            action: []
          }
        ]
      };
      if (state.ruleType === 'realTime') {
        if (state.inputList[0].device === '') {
          message.error('Please Select Equipment In If Condition for RealTime Rule');
        } else {
          obj[prop][0].device = state.inputList[0].device;
          setState(obj);
        }
      } else {
        setState(obj);
      }
    }
  };
  const handleelse = () => {
    const { elseList } = state;
    if (elseList.length === 0) {
      let obj = {
        conif: true,
        conelseif: true,
        conelse: true,
        elseList: [{ tagName: '', operater: '', value: '', action: [] }]
      };
      if (state.ruleType === 'realTime') {
        if (state.inputList[0].device === '') {
          message.error('Please Select Equipment In If Condition for RealTime Rule');
        } else {
          obj['elseList'][0].device = state.inputList[0].device;
          setState({
            ...state,
            conif: true,
            conelseif: true,
            conelse: true,
            elseList: [{ tagName: '', operater: '', value: '', action: [] }]
          });
        }
      } else {
        setState({
          ...state,
          conif: true,
          conelseif: true,
          conelse: true,
          elseList: [{ tagName: '', operater: '', value: '', action: [] }]
        });
      }
    }
  };
  const checkonChange = (values, type, index) => {
    const { translationCache } = props;
    let translationAction;
    let keys = Object.keys(translationCache);
    let arrConverter = values.map((action) => {
      let data = keys.filter((labels) => {
        return translationCache[labels] === action;
      });
      if (data[0] === undefined) {
        return [action];
      } else {
        return data;
      }
    });
    translationAction = arrConverter.map((indexedArry) => {
      return indexedArry[0];
    });
    let typeList = {};
    if (index === undefined) {
      typeList = { ...state[type] };
      typeList['action'] = translationAction;
    } else {
      typeList = [...state[type]];
      typeList[index]['action'] = translationAction;
    }
    setState({
      ...state,
      [type]: typeList
    });
  };
  const handleDetailsName = (e) => {
    setState({
      ...state,
      displayRuleName: e.target.value
    });
  };
  const handleDetailsDesc = (e) => {
    setState({
      ...state,
      ruleDesc: e.target.value
    });
  };
  const editrule = async () => {
    const result = scriptGenerator(state);
    const replicateList = state.replicateDevices;
    // setState({
    //   ...state,
    //   replicateDevices: replicateList
    // });
    // delete state.replicateDevices;
    if (result.errorClearnce) {
      const {
        displayRuleName,
        ruleDesc,
        ruleType,
        batchPriority,
        onChange,
        Group,
        NumberOfNotifications
      } = state;
      let payLoad = {
        name: displayRuleName,
        displayRuleName: displayRuleName,
        description: ruleDesc,
        NumberOfNotifications: NumberOfNotifications === '' ? null : NumberOfNotifications,
        payload: {
          ...state,
          treeData: [],
          userProfile: {},
          parameterChangeList: [],
          deviceList: [],
          deviceListData: [],
          deviceTypeList: [],
          parametersList: [],
          recipientList: []
        },
        tags: result.tagNames,
        script: result.script,
        ruleType: ruleType,
        batchPriority: batchPriority,
        onChange: onChange,
        onContinous: onContinous,
        mailRecipients: state.mailRecipients ? state.mailRecipients : [],
        url: state.url ? state.url : [],
        ...(ruleType && ruleType === 'deviceType' ? { Group } : {})
      };
      let data = await editRule(id, payLoad);

      if (data && data.status === 200) {
        replicateList &&
          Array.isArray(replicateList) &&
          replicateList.map(async (replicateDevice, i) => {
            let replicatedState = {
              ...replicateRule(state, replicateDevice)
            };
            const result = scriptGenerator(replicatedState);
            replicatedState.replicateDevices = [];
            try {
              let repData = await saveRule({
                name: displayRuleName,
                displayRuleName: displayRuleName,
                description: ruleDesc,
                payload: replicatedState,
                tags: result.tagNames,
                script: result.script,
                ruleType,
                batchPriority,
                onChange,
                onContinous: onContinous,
                replicate: 'true',
                mailRecipients: state.mailRecipients ? state.mailRecipients : [],
                parentId: data.data && data.data.Id ? data.data.Id : ''
              });
              if (repData.status === 201 || repData.status === 200) {
                message.success('Rule Updated');
              }
              if (i === replicateList.length - 1) {
                navigate(`/rubus/RulesList`);
              }
            } catch (error) {
              if (i === replicateList.length - 1) {
                navigate(`/rubus/RulesList`);
              }
            }
          });
        if (replicateList.length === 0) {
          message.success('Rule Updated');
          navigate(`/rubus/RulesList`);
        }
      }
    }
  };
  const handleRuleType = async (value, mode) => {
setBatchPriority(value);
    if (value === 'batch' && mode === 'ruleType') {
      //If ruleType is batch,call priority list
      let priorityFrequencyList = await priorityList();
      
      setState({
        ...state,
        [mode]: value,
        priorityTypes: priorityFrequencyList ? priorityFrequencyList : []
      });
      // setState({
      //   ...state,
      //   priorityTypes: priorityFrequencyList ? priorityFrequencyList : []
      // });
    } else {
      setState({
        ...state,
        [mode]: value
      });
    }
  };
  const handleRecipientList = (value, mode) => {
    if (value && Array.isArray(value) && value.length > 5) {
      message.error('Max 5 Users are allowed');
    } else {
      setState({
        ...state,
        [mode]: value
      });
    }
  };
  const handleNotificationChange = (e, mode) => {
    setState({
      ...state,
      [mode]: e.target.value
    });
  };
  const handleurl = (e, mode) => {
    setState({
      ...state,
      [mode]: e.target.value
    });
  };
  const handleRulebody = (e, mode) => {
    setState({
      ...state,
      [mode]: e.target.value
    });
  };
  const handledownTimedeviceSelect = async (value, mode) => {
    let list = { ...state[mode] };
    list['device'] = value;
    setState({
      ...state,
      [mode]: list
    });
  };
  const handleparameterTypeSelect = (value, index, mode) => {
    const list = [...state[mode]];
    list[index]['parameterType'] = value;
    setState({
      ...state,
      [mode]: list
    });
  };
  const handleParameterSelect = async (value, index, mode) => {
    const list = state && state[mode] && [...state[mode]];
    list[index]['parameterName'] = value;
    list[index]['device'] = '';
    list[index]['tagName'] = '';
    list[index]['operater'] = '';
    list[index]['value'] = '';
    setIndexDevice(index);
    setEnable(true);
    setState({
      // tabActivationkey: state.tabActivationkey,
      ...state,
      [mode]: list,
      parameter: value,
      ruleType: 'realTime',
      selectedDevices: []
    });
    setParameterName(value);
    setSelectedEquipment([]);
  };
  const handleSelectHierarchy = async (value, index, mode, code) => {
    const list = state && state[mode] && [...state[mode]];
    if (list && list !== undefined) {
      list[index]['HierarchyId'] = value;
      setState({
        ...state,
        [mode]: list
      });
      if (code === 'initail') {
        let data = await getHierarchyLevels(value, state.inputList[index].parameterName);
        if (data) {
          setTreeData(data);
          setState({
            ...state,
            selectedDevices: [],
            parametersList:[]
          });
        }
      } else {
        let data = await getHierarchyLevels(value, state.inputList[index].parameterName);
        if (data) {
          setTreeData(data);
          setState({
            ...state,
            selectedDevices: [],
            parametersList:[]
          });
        }
      }
    }
  };
  const handledeviceSelect = async (value, mode, index) => {
    let list = [...state[mode]];
    list[index]['device'] = value;
    list[index]['tagName'] = '';
    list[index]['operater'] = '';
    list[index]['value'] = '';
    setState({
      ...state,
      selectedDevices: [value] || []
    });
    let SelectedDevices = state.selectedDevices;
    if (SelectedDevices && SelectedDevices.includes(value)) {
      setState({
        ...state,
        [mode]: list
      });
    } else {
      try {
        if (state.tabActivationkey === 'DeviceRules') {
          // state.selectedDevices.push(value);
          let parametersData = await getparameterList(value, state.inputList[0].parameterName);
          setState({
            ...state,
            [mode]: list,
            parametersList: parametersData.data,
            selectedDevices: [value]
          });
          setSelectedEquipment(value);
        } else if (state.tabActivationkey === 'DeviceTypeRules') {
          // state.selectedDevices.push(value);
          list[index]['deviceType'] = value;
          let parametersList = await getparameterListByDeviceType(
            state.inputList[0].parameterName,
            value
          );
          setState({
            ...state,
            [mode]: list
          });
          setState({
            ...state,
            parametersList
          });
        } else {
          // state.selectedDevices.push(value);
          setState({
            ...state,
            selectedDevices: [value]
          });
          let columsData = await getColumnsList([value]);
          // let columsData = await getColumnsList(state.selectedDevices);
          setState({
            ...state,
            [mode]: list
          });
          setState({
            ...state,
            columnList: columsData.data
          });
        }
      } catch (error) {
        message.error('Could Not Able To Load ParametersList');
      }
    }
  };
  const handleTableDeviceSelect = async (value, index, mode) => {
    const list = [...state[mode]];
    list[index]['tableDevice'] = value;
    setState({
      ...state,
      [mode]: list
    });
  };
  const handleVisibleChange = (visible, type) => {
    setState({
      ...state,
      [type]: visible
    });
  };
  const handlePopoverOnclick = (index, mode, type, dignosis, flag) => {
    if (type === 'close') {
      let list = [...state[mode]];
      list[index][dignosis] = '';
      setState({
        ...state,
        [flag]: false
      });
    } else {
      setState({
        ...state,
        [dignosis]: false
      });
    }
  };

  const handleTagSelect = (value, index, mode) => {
    const list = [...state[mode]];
    list[index]['tagName'] = value;
    setState({
      ...state,
      // [['inputList'][index]['tagName']]:value,
      ParameterCode: value
    });
  };

  const handleDelay = (value, type, index) => {
    let dateValue;
    if (value instanceof Date) {
      dateValue = value;
    } else {
      // Attempt to create a Date object from the value
      dateValue = new Date(value);
      if (isNaN(dateValue.getTime())) {
        console.error('Invalid date value:', value);
        return; // Exit the function if the date is invalid
      }
    }

    let time = dateValue.toTimeString().split(' ')[0];
    let splitTime = time.split(':');

    let delayTime =
      parseInt(splitTime[0], 10) * 3600 +
      parseInt(splitTime[1], 10) * 60 +
      parseInt(splitTime[2], 10);

    let typeList;

    if (index === undefined) {
      typeList = { ...state[type] };
      typeList['delay'] = [delayTime, time];
    } else {
      typeList = [...state[type]];
      typeList[index] = { ...typeList[index], delay: [delayTime, time] };
    }

    setState({
      ...state,
      [type]: typeList
    });
  };
  const handleFrequency = (value, type, index) => {
    let dateValue;
    if (value && value._d instanceof Date) {
      dateValue = value._d;
    } else {
      dateValue = new Date(value);
      if (isNaN(dateValue.getTime())) {
        console.error('Invalid date value:', value);
        return;
      }
    }

    let time = dateValue.toTimeString().split(' ')[0];
    let splitTime = time.split(':');
    let frequencyTime =
      parseInt(splitTime[0], 10) * 3600 +
      parseInt(splitTime[1], 10) * 60 +
      parseInt(splitTime[2], 10);

    let typeList;

    if (index === undefined) {
      typeList = { ...state[type] };
      typeList['frequency'] = [frequencyTime, time];
    } else {
      typeList = [...state[type]];
      typeList[index] = { ...typeList[index], frequency: [frequencyTime, time] };
    }

    setState({
      ...state,
      [type]: typeList
    });
  };
  const handleRadioButton = (e) => {
    setState({
      ...state,
      onChange: e.target.checked
    });
  };
  const handleContinous = (e) => {
    setOnContinous(e.target.checked);
    setState({
      ...state,
      onContinous: e.target.checked
    });
  };
  const handlePickyChange = (values) => {
    setState({
      ...state,
      replicateDevices: values
    });
  };
  const handleTabs = (value) => {
    switch (value) {
      case 'DeviceRules': {
        let devicObj = cloneDeep(defaultState);
        devicObj.tabActivationkey = value;
        devicObj.ruleName = state.ruleName;
        devicObj.ruleDesc = state.ruleDesc;
        setState(devicObj);
        break;
      }
      case 'DeviceTypeRules': {
        let deviceTypeObj = cloneDeep(deviceTypedefaultState);
        deviceTypeObj.tabActivationkey = value;
        deviceTypeObj.ruleName = state.ruleName;
        deviceTypeObj.ruleDesc = state.ruleDesc;
        setState(deviceTypeObj);
        break;
      }
      case 'RestApi': {
        let predicObj = cloneDeep(predictionDefaultState);
        predicObj.tabActivationkey = value;
        predicObj.ruleName = state.ruleName;
        predicObj.ruleDesc = state.ruleDesc;
        setState(predicObj);
        break;
      }
      case 'noDevice': {
        let nodevicObj = cloneDeep(noDeviceDefault);
        nodevicObj.tabActivationkey = value;
        nodevicObj.ruleName = state.ruleName;
        nodevicObj.ruleDesc = state.ruleDesc;
        setState(nodevicObj);
        break;
      }
      case 'table': {
        let tableObj = cloneDeep(tableState);
        tableObj.tabActivationkey = value;
        tableObj.ruleName = state.ruleName;
        tableObj.ruleDesc = state.ruleDesc;
        setState(tableObj);
        break;
      }
      default:
        break;
    }
  };
  // const { displayRuleName, ruleDesc, indexDevice, enable, treeData } = this.state;
  const { translationCache } = props;
  const Methods = {
    handledeviceSelect,
    handleParameterSelect,
    handledownTimedeviceSelect,
    handleelseif,
    handleelse,
    handleRuleType,
    handleRecipientList,
    handleNotificationChange,
    handleurl,
    handleRulebody,
    handleDelay,
    handleSelectHierarchy,
    handleFrequency,
    checkonChange,
    handleTagSelect,
    handlePickyChange,
    handleInputChange,
    handleRadioButton,
    handleContinous,
    handleAddClick,
    handleRemoveClick,
    handleVisibleChange,
    handlePopoverOnclick,
    handleTextAreaChange,
    handleConditionchange,
    handleTableDeviceSelect,
    handleparameterTypeSelect
  };
  return (
    <StyledHomepage>
      <div style={{ margin: '10px 0px' }}>
        <Button
          type="primary"
          onClick={() => {
            navigate('/rubus/RulesList');
          }}>
          {' '}
          <LeftOutlined />{' '}
          {translationCache && translationCache[`${constants.Go_Back}`]
            ? translationCache[`${constants.Go_Back}`]
            : `${constants.Go_Back}`}{' '}
        </Button>
      </div>
      <div>
        <Row style={{ marginBottom: '1%' }}>
          <Col span={12}>
            <BlockedLabel>
              {translationCache && translationCache[`${constants.Rule_Name}`]
                ? translationCache[`${constants.Rule_Name}`]
                : `${constants.Rule_Name}`}
            </BlockedLabel>
            <Input
              style={{ width: '55%' }}
              placeholder={
                translationCache && translationCache[`${constants.phName}`]
                  ? translationCache[`${constants.phName}`]
                  : `${constants.phName}`
              }
              name="displayRuleName"
              value={state.displayRuleName}
              maxLength="25"
              onChange={(e) => {
                e.persist();
                handleDetailsName(e);
              }}
            />
          </Col>
          <Col span={12}>
            <BlockedLabel>
              {translationCache &&
              translationCache[`${constants.Rule_Description}`] &&
              translationCache[`${constants.Rule_Description}`]
                ? translationCache[`${constants.Rule_Description}`]
                : `${constants.Rule_Description}`}
            </BlockedLabel>
            <Input
              style={{ width: '55%' }}
              placeholder={
                translationCache &&
                translationCache[`${constants.phDescription}`] &&
                translationCache[`${constants.phDescription}`]
                  ? translationCache[`${constants.phDescription}`]
                  : `${constants.phDescription}`
              }
              maxLength="50"
              name="ruleDesc"
              value={state.ruleDesc}
              onChange={(e) => handleDetailsDesc(e)}
            />
          </Col>
        </Row>
        <Tabs
          activeKey={state.tabActivationkey}
          onChange={handleTabs}
          type="card"
          defaultActiveKey="DeviceRules">
          <TabPane
            tab={
              translationCache && translationCache[`${constants.deviceRules}`]
                ? translationCache[`${constants.deviceRules}`]
                : `${constants.deviceRules}`
            }
            key="DeviceRules">
            <DeviceRuleView
              selectedDevices={selectedEquipment}
              replicateDevices={state.replicateDevices}
              parameterChangeList={parameterChangeList}
              batchPriority={batchPriority}
              parameterName={parameterName}
              // userProfile={state.userProfile}
              edit={state.edit}
              // disabledParamTypeDevice={state.disabledParamTypeDevice}
              onContinous={onContinous}
              indexDevice={indexDevice}
              enable={enable}
              handledeviceSelect={handledeviceSelect}
              treeData={treeData}
              conif={Conif}
              config={state}
              Methods={Methods}

              translationCache={props.translationCache}
            />
          </TabPane>
          <TabPane
            tab={
              translationCache && translationCache[`${constants.deviceTypeRules}`]
                ? translationCache[`${constants.deviceTypeRules}`]
                : `${constants.deviceTypeRules}`
            }
            key="DeviceTypeRules">
            <DeviceTypeRule
              // userProfile={this.state.userProfile}
              // disabledParamTypeDevice={this.state.disabledParamTypeDevice}
              onContinous={onContinous}
              parameterChangeList={parameterChangeList}
              parameterName={parameterName}
              indexDevice={indexDevice1}
              enable={enable}
              handledeviceSelect={handledeviceSelect}
              treeData={treeData}
              config={state}
              //  .deviceTypedefaultState = { deviceTypedefaultState}
              Methods={Methods}
              translationCache={props.translationCache}
            />
          </TabPane>
          {/* <TabPane
              tab={
                translationCache &&
                translationCache[`${constants.nodeviceRules}`] &&
                translationCache[`${constants.nodeviceRules}`]
                  ? translationCache[`${constants.nodeviceRules}`]
                  : `${constants.nodeviceRules}`
              }
              key="noDevice"
            >
              <NodeviceView
                config={this.state}
                Methods={Methods}
                translationCache={this.props.translationCache}
                language={this.props.language}
              />
            </TabPane>
            <TabPane
              tab={
                translationCache &&
                translationCache[`${constants.restApiRules}`] &&
                translationCache[`${constants.restApiRules}`]
                  ? translationCache[`${constants.restApiRules}`]
                  : `${constants.restApiRules}`
              }
              key="RestApi"
            >
              <Restapi
                config={this.state}
                Methods={Methods}
                translationCache={this.props.translationCache}
                language={this.props.language}
              />
            </TabPane>
            <TabPane
              tab={
                translationCache &&
                translationCache[`${constants.tableRules}`] &&
                translationCache[`${constants.tableRules}`]
                  ? translationCache[`${constants.tableRules}`]
                  : `${constants.tableRules}`
              }
              key="table"
            >
              <TableRuleView
                config={this.state}
                Methods={Methods}
                translationCache={this.props.translationCache}
                language={this.props.language}
              />
            </TabPane> */}
        </Tabs>
        <div style={{ display: 'flex', flexDirection: 'row-reverse', margin: '10px 0px' }}>
          {state.edit ? (
            <Button
              type="primary"
              onClick={() => {
                setState({
                  ...state,
                  replicateDevices: state.replicateDevices
                });
                setSelectedEquipment(state.selectedDevices);
                editrule();
              }}
              disabled={!permissionsArray.includes('update') ? true : false}>
              {translationCache && translationCache[`${constants.update}`]
                ? translationCache[`${constants.update}`]
                : `${constants.update}`}
            </Button>
          ) : (
            <Button
              type="primary"
              disabled={!permissionsArray.includes('create') ? true : false}
              onClick={() => {
                saveRules();
              }}>
              {translationCache && translationCache[`${constants.save}`]
                ? translationCache[`${constants.save}`]
                : `${constants.save}`}
            </Button>
          )}
        </div>
      </div>
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
    defaultHiearchy: state.LayoutReducer.DefaultHierarchy
  };
};
export default connect(mapStateToProps)(RuleEngine);
